<template>
<div>
  <v-textarea
    :label='label'
    @click:append='showdialog=true'
    append-icon='fullscreen' v-bind='initialAttrs' v-model='text' >
  </v-textarea>
  <v-dialog v-model='showdialog' :fullscreen='fullscreen' >
    <v-toolbar dense flat >
      <v-spacer></v-spacer>
      <v-btn @click='showdialog=false' icon >
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-textarea
          :label='label'
          v-model='text' v-bind='attrs' >
        </v-textarea>
      </v-card-text>
      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn @click='showdialog=false' flat text >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  name: 'TextEditor',
  props: {
    value: { type: String, required: false, default: '' },
    label: { type: String, required: false },
    fullscreen: { type: Boolean, default: false },
    supportsMarkdown: { type: Boolean, default: false },
    initialAttrs: { type: Object, default: () => { return {} } },
    attrs: {
      type: Object,
      default: () => {
        return {
          rows: 30,
          counter: true
        }
      }
    }
  },
  data () {
    return {
      showdialog: false,
      text: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.text = this.value
          if (this.value === '{}') { this.text = '' }
        }
      }
    },
    text () {
      this.$emit('input', this.text)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TextEditor.vue?6f6dc030